<app-base-overlay title="Choose a variable">
  <div body class="flex min-h-0 flex-col gap-4">
    <div class="grid grid-cols-3 gap-2">
      @for (tab of sourceTabs; track tab.id) {
        <button
          type="button"
          class="flex cursor-pointer items-center gap-2 rounded-xl border px-3 py-2.5 text-left transition"
          [class.border-primary-200]="activeSource() === tab.id"
          [class.bg-primary-50]="activeSource() === tab.id"
          [class.text-primary-700]="activeSource() === tab.id"
          [class.border-slate-200]="activeSource() !== tab.id"
          [class.bg-white]="activeSource() !== tab.id"
          [class.text-slate-600]="activeSource() !== tab.id"
          [class.hover:bg-slate-50]="activeSource() !== tab.id"
          (click)="setActiveSource(tab.id)">
          <app-svg-icon class="shrink-0" [src]="tab.iconSrc" [size]="18" />
          <span class="min-w-0 flex-1 truncate text-xs font-semibold">
            {{ tab.label }}
          </span>
          <span
            class="shrink-0 rounded-md px-1.5 py-0.5 text-[11px] font-medium"
            [class.bg-primary-100]="activeSource() === tab.id"
            [class.text-primary-700]="activeSource() === tab.id"
            [class.bg-slate-100]="activeSource() !== tab.id"
            [class.text-slate-500]="activeSource() !== tab.id">
            {{ sourceCount(tab.id) }}
          </span>
        </button>
      }
    </div>

    <div class="flex items-end gap-2">
      <lib-signal-text-field
        class="min-w-0 flex-1"
        label=""
        placeholder="Search variables..."
        [value]="search()"
        [debounceValueChange]="true"
        (valueChange)="onSearchChange($event)" />
      @if (showCreateVariable()) {
        <button
          type="button"
          class="mb-0.5 inline-flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-xl border border-slate-200 bg-white text-sm font-medium text-slate-700 transition hover:bg-slate-50 sm:w-auto sm:px-3"
          aria-label="Create variable"
          (click)="openCreateVariable()">
          <app-svg-icon src="assets/icons/plus.svg" [size]="18" />
          <span class="hidden sm:inline">Create variable</span>
        </button>
      }
    </div>

    <div class="max-h-[22rem] min-h-[12rem] overflow-y-auto">
      @if (isLoading()) {
        <p class="py-8 text-center text-sm text-slate-500">Loading variables…</p>
      } @else if (isComingSoon()) {
        <p class="py-8 text-center text-sm text-slate-500">
          Coming soon. Data library and system variables are available today.
        </p>
      } @else if (isEmpty()) {
        <p class="py-8 text-center text-sm text-slate-500">
          @if (activeSource() === 'system') {
            No system variables match this field type.
          } @else {
            No variables found. Create one in Data Library first.
          }
        </p>
      } @else {
        <ul class="m-0 list-none p-0">
          @for (item of filteredItems(); track item.id) {
            <li>
              <button
                type="button"
                class="flex w-full cursor-pointer items-center gap-3 rounded-xl border-0 bg-transparent px-1 py-2.5 text-left transition hover:bg-slate-50"
                (click)="selectVariable(item)">
                <span
                  [class]="
                    'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50 ' +
                    typeIconClass(item.valueType)
                  ">
                  <app-svg-icon [src]="typeIconSrc(item.valueType)" [size]="18" />
                </span>
                <span class="min-w-0 flex-1 truncate text-sm font-medium text-slate-900">
                  {{ item.name }}
                </span>
                <span
                  [class]="
                    'max-w-[10rem] shrink-0 truncate rounded-full px-2.5 py-1 text-xs font-medium ' +
                    valueBadgeClass(item.valueType)
                  ">
                  {{ item.valueLabel || '—' }}
                </span>
                <app-svg-icon
                  class="shrink-0 text-slate-300"
                  src="assets/icons/chevron-right.svg"
                  [size]="16" />
              </button>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</app-base-overlay>
